import s from "./ghl-ui.es1406.js";
import u from "./ghl-ui.es373.js";
function o(r, e) {
  var t = -1, a = u(r) ? Array(r.length) : [];
  return s(r, function(f, i, n) {
    a[++t] = e(f, i, n);
  }), a;
}
export {
  o as default
};
